import React from 'react';

import sy from '~/styles';
import {Link} from '~/components/controls';
import PropTypes from 'prop-types';

const ChangeRobCodeLink = ({
  rob,
  task_id,
  rob_code,
  rob_description,
  work_id,
  custom_codes,
  onPress,
}) => {
  let code = rob_code;
  let description = rob_description;
  if (custom_codes[work_id]) {
    ({code, description} = custom_codes[work_id]);
  }

  if (!code) {
    return <></>;
  }

  let disabled = false;
  if (task_id && rob?.components[task_id]) {
    disabled = true;
  }

  return (
    <Link
      disabled={disabled}
      textStyle={[sy.small, sy['text-lightgray']]}
      onPress={() => onPress(work_id, code)}>
      {code}&nbsp;&middot;&nbsp;{description}
    </Link>
  );
};
ChangeRobCodeLink.propTypes = {
  rob: PropTypes.any,
  task_id: PropTypes.any,
  rob_code: PropTypes.any,
  rob_description: PropTypes.any,
  work_id: PropTypes.any,
  custom_codes: PropTypes.any,
  onPress: PropTypes.any,
};


export default ChangeRobCodeLink;
